"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireWildcard"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper"));

var _admin = require("@/api/admin");

var _baseConfig = require("@/api/baseConfig");

var _role = require("@/api/role");

var _storage = require("@/api/storage");

var _auth = require("@/utils/auth");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var _default = {
  name: 'Admin',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (_this.dialogStatus == 'create') {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;

          if (!regex.test(value)) {
            callback(new Error('至少6位，包含大写字母、小写字母、数字、特殊字符'));
          } else callback();
        }
      }
    };

    return {
      uploadPath: _storage.uploadPath,
      list: null,
      total: 0,
      skills: [{
        id: 0,
        name: 'CSR-400'
      }, {
        id: 1,
        name: 'CSR-OB'
      }, {
        id: 2,
        name: 'TL'
      }],
      departments: [],
      roleOptions: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        username: undefined,
        userAccount: undefined,
        sort: 'state,create_time',
        order: 'desc'
      },
      dataForm: {
        id: undefined,
        userName: undefined,
        userPassword: undefined,
        userAccount: undefined,
        avatar: undefined,
        roleIds: [],
        extNo: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        UserName: [{
          required: true,
          message: '管理员名称不能为空',
          trigger: 'blur'
        }],
        UserPassword: [{
          required: true,
          message: '密码不能为空',
          trigger: 'blur'
        }, {
          validator: validatePass,
          trigger: 'blur'
        }],
        roleIds: [{
          required: true,
          message: '角色不能为空',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '技能角色不能为空',
          trigger: 'blur'
        }]
      },
      downloadLoading: false
    };
  },
  computed: {
    headers: function headers() {
      return {
        'X-JZ-Admin-Token': (0, _auth.getToken)()
      };
    }
  },
  created: function created() {
    var _this2 = this;

    this.getList();
    (0, _role.roleOptions)().then(function (response) {
      _this2.roleOptions = response.data.data.list;
    });
  },
  methods: {
    formatRole: function formatRole(roleId) {
      for (var i = 0; i < this.roleOptions.length; i++) {
        if (roleId === this.roleOptions[i].value) {
          return this.roleOptions[i].label;
        }
      }

      return '';
    },
    handleEnable: function handleEnable(row) {
      var _this3 = this;

      this.$confirm("确定要启用" + row.userName + "账号吗？", "提示", {
        confirmButtonText: "启用",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _admin.enableAdmin)(row).then(function (res) {
          _this3.$notify.success({
            title: '成功',
            message: '账号启用成功'
          });

          _this3.getList();
        });
      });
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;
      (0, _admin.listAdmin)(this.listQuery).then(function (response) {
        _this4.list = response.data.data.list;
        _this4.total = response.data.data.total;
        _this4.listLoading = false;
      }).catch(function () {
        _this4.list = [];
        _this4.total = 0;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm: function resetForm() {
      this.dataForm = {
        id: undefined,
        userName: undefined,
        userAccount: undefined,
        userPassword: undefined,
        avatar: undefined,
        roleIds: [],
        departmentName: undefined
      };
    },
    uploadAvatar: function uploadAvatar(response) {
      this.dataForm.avatar = response.data.url;
    },
    handleCreate: function handleCreate() {
      var _this5 = this;

      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this5.$refs['dataForm'].clearValidate();
      });
    },
    createData: function createData() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _admin.createAdmin)(_this6.dataForm).then(function (response) {
            _this6.list.unshift(response.data.data);

            _this6.dialogFormVisible = false;

            _this6.$notify.success({
              title: '成功',
              message: '添加管理员成功'
            });
          }).catch(function (response) {
            _this6.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this7 = this;

      this.dataForm = Object.assign({}, row);
      console.info(this.dataForm);
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this7.$refs['dataForm'].clearValidate();
      });
    },
    handleBD: function handleBD(row) {
      var _this8 = this;

      this.$confirm("是否确定设置为BD吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _baseConfig.saveBD)({
          bdIds: [row.id]
        }).then(function (response) {
          _this8.$notify.success({
            title: "成功",
            message: "设置成功"
          });

          _this8.getList();
        }).catch(function (response) {
          _this8.$notify.error({
            title: "失败",
            message: response.data.errmsg
          });
        });
      });
    },
    deleteBD: function deleteBD(row) {
      var _this9 = this;

      this.$confirm("确定删除BD吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _baseConfig.deleteBD)({
          bdId: row.id
        }).then(function (response) {
          _this9.$notify.success({
            title: "成功",
            message: "删除成功"
          });

          _this9.getList();
        }).catch(function (response) {
          _this9.$notify.error({
            title: "失败",
            message: response.data.errmsg
          });
        });
      });
    },
    updateData: function updateData() {
      var _this10 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _admin.updateAdmin)(_this10.dataForm).then(function () {
            var _iterator = (0, _createForOfIteratorHelper2.default)(_this10.list),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var v = _step.value;

                if (v.id === _this10.dataForm.id) {
                  var index = _this10.list.indexOf(v);

                  _this10.list.splice(index, 1, _this10.dataForm);

                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this10.dialogFormVisible = false;

            _this10.$notify.success({
              title: '成功',
              message: '更新管理员成功'
            });
          }).catch(function (response) {
            _this10.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this11 = this;

      (0, _admin.deleteAdmin)(row).then(function (response) {
        _this11.$notify.success({
          title: '成功',
          message: '删除管理员成功'
        });

        _this11.getList();
      }).catch(function (response) {
        _this11.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    },
    handleDownload: function handleDownload() {
      var _this12 = this;

      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['管理员ID', '管理员名称', '管理员头像'];
        var filterVal = ['id', 'username', 'avatar'];
        excel.export_json_to_excel2(tHeader, _this12.list, filterVal, '管理员信息');
        _this12.downloadLoading = false;
      });
    }
  }
};
exports.default = _default;